<template>
    <div
        class="slide-container"
        :style="imgStyle"
    >
        <div class="content">
            <p
                v-for="text in item.content"
                :style="text.style"
            >
                {{text.text}}
            </p>
        </div>
        <a
            v-if="item.url.startsWith('http')"
            :href="item.url"
            class="link"
            target="_blank"
        ></a>
        <router-link
            v-else
            :to="item.url"
            class="link"
        ></router-link>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    computed: {
        imgStyle(){
            return {
                backgroundImage: `url('${this.item.file_path}')`
            };
        },
    },
}
</script>

<style lang="scss" scoped>

.slide-container{
    position: relative;
    display: flex;
    align-items: center;
    color: white;
    width: 100%;
    //height: 100%;
    //width: 960px;
    height: 330px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    
    .content{
        margin: 0 10%;
        width: 80%;
        
        p{
            text-transform: uppercase;
            font-weight: bold;
            margin: 0;
            font-size: 2.5em;

            &:nth-child(1) {
                font-size: 1.5em;
            }
        }
    }

    @media (max-width: 960px){
        width: 100%;
        height: 200px;

        .content{
            p{
                font-size: 2em;
                &:nth-child(1) {
                    font-size: 1.5em;
                }
            }
        }
    }
    
    .link{
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>
